<template>
  <router-view />
</template>

<script>
  export default {
    name: 'InstructionsIndex'
  }
</script>
